import {
  Button, ButtonSize, ButtonColor, useModal, Modal, Typography, Portal,
} from '@doveit/bricks';
import React, {
  FunctionComponent, useCallback,
} from 'react';
import { WebSearchCriteria } from '../../../services/dtos';
import CreateWebSearchCriteria from '../../containers/create-web-search-criteria/CreateWebSearchCriteria';
import { BELL_CHECK } from '../../themes/icons';

export interface CreateWebSearchCriteriaButtonProps extends React.AriaAttributes {
  initialValues?: Partial<WebSearchCriteria>,
  disabled?: boolean,
  expanded?: boolean,
  dataRef?: string,
  dataTracking?: string,
  onSuccess?: (webSearchCriteria: WebSearchCriteria) => void,
}

const CreateWebSearchCriteriaButton: FunctionComponent<CreateWebSearchCriteriaButtonProps> = ({
  initialValues,
  disabled,
  expanded,
  dataRef = 'save-search-button',
  dataTracking,
  onSuccess,
  ...rest
}) => {
  const saveSearchModal = useModal();

  const internalOnSuccess = useCallback((webSearchCriteria: WebSearchCriteria) => {
    saveSearchModal.close();
    if (onSuccess) {
      onSuccess(webSearchCriteria);
    }
  }, [onSuccess, saveSearchModal]);

  return (
    <>
      <Button
        {...rest}
        dataRef={dataRef}
        dataTracking={dataTracking}
        icon={BELL_CHECK}
        label="Salva ricerca"
        size={ButtonSize.SMALL}
        color={ButtonColor.PRIMARY}
        disabled={disabled}
        expanded={expanded}
        onClick={saveSearchModal.open}
      />
      <Portal>
        <Modal
          data-ref={`${dataRef}-modal`}
          open={saveSearchModal.isOpen}
          onCloseHandler={saveSearchModal.close}
        >
          <Modal.Close />

          <Modal.Header>
            <Typography.H3>
              Salva la tua ricerca
            </Typography.H3>
          </Modal.Header>

          <Modal.Body padded>
            <CreateWebSearchCriteria
              initialValues={initialValues}
              onSuccess={internalOnSuccess}
              dataRef={dataRef}
            />
          </Modal.Body>
        </Modal>
      </Portal>
    </>
  );
};

export default CreateWebSearchCriteriaButton;
